import { WSService } from "../../../utils/WSService";
import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/banking/internal-accounts");

// NOTE: list / get / balance / create / transfer were migrated to the v3 SDK
// (`internalAccountsApi`, see src/v3/query/finance/internalAccount). Only the
// per-account transactions list stays on v1 because the v3 endpoint
// (`GET /v3/finance/internal-accounts/:id/transactions`) is still 501.
export const listInternalAccountTransactions = async (
  internalAccountId: string,
  query?: bankingApiSpec.operations["listInternalAccountTransactions"]["parameters"]["query"]
): Promise<
  bankingApiSpec.operations["listInternalAccountTransactions"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get(
    "/" + internalAccountId + "/transactions",
    { params: query }
  );
  return data;
};
